import { Button, Card, Form, Input, notification } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePasswordResetConfirmMutation } from '../../../features/auth/authApi';
import { useParams } from 'react-router';

const SetNewPasswordPage = () => {
    const { t } = useTranslation();
    const { uid64: uid, token } = useParams();
    const [passwordResetConfirm, {}] = usePasswordResetConfirmMutation();

    const onOk = (values) => {
        const payload = { ...values, uid, token };

        passwordResetConfirm(payload)
            .unwrap()
            .then((res) => {
                notification.success({
                    message: t('Reset Password'),
                    description: t('Password reset successfully'),
                });
            })
            .catch((err) => {
                notification.error({
                    message: t('Reset Password'),
                    description: t(
                        'Something went wrong. Please try again later'
                    ),
                });
            });
    };

    return (
        <Card
            title="Reset Password"
            style={{ width: 500, margin: 'auto', marginTop: 50 }}
        >
            <Form
                name="reset-password"
                initialValues={{ remember: true }}
                onFinish={onOk}
                layout="vertical"
            >
                <Form.Item
                    label={t('New Password 1')}
                    name="new_password1"
                    rules={[
                        {
                            required: true,
                            message: t('Please enter your password') as string,
                        },
                    ]}
                >
                    <Input.Password data-cy="reset-password-password1" />
                </Form.Item>
                <Form.Item
                    label={t('New Password 2')}
                    name="new_password2"
                    rules={[
                        {
                            required: true,
                            message: t('Please enter your password') as string,
                        },
                    ]}
                >
                    <Input.Password data-cy="reset-password-password2" />
                </Form.Item>
                <Form.Item>
                    <Button
                        block
                        type="primary"
                        htmlType="submit"
                        data-cy="reset-password-submit"
                    >
                        {t('Reset Password')}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default SetNewPasswordPage;
